import Breadcrumb from '../../components/common/Breadcrumb'
import styled from '@emotion/styled'
import { useRouter } from '../../utils/helper'
import EClaimInfo from '../EClaimDetail/EClaimInfo'
import Loading from '../../components/common/Loading'
import { eClaim, eClaimDetail, enrollment, home } from '../../constant/path'
import { mobile, useScreen } from '../../utils/responsive-helper'
import { useMemo } from 'react'
import Headbar from '../../components/common/HeadBar'
import * as paths from '../../constant/path'
import { useSelector } from 'react-redux'
import { RootState } from '../../redux-store'
import color from '../../constant/colors'
import { useGetExerciseById } from '../../services/exercise/exercise-query'
import ExerciseForm from './ExerciseForm'
import { ExerciseInfoWithConcentDate, ExerciseInfoWithoutConcentDate } from '../../redux-store/exercise-reducer'

const BackgroundHeader = styled.div`
  background-color: ${color.CHOICES_PRIMARY};
  width: calc(100% - 32px);
  height: 266px;
  margin-top: 0px !important;
  position: absolute;

  ${mobile} {
    width: 100%;
  }
`
const Layout = styled.div`
  width: 768px;
  margin: 0 auto;
  z-index: 1;
  > * {
    margin-top: 24px;
  }

  ${mobile} {
    width: 100%;
  }
`

const ExerciseDetail = () => {
  const { query } = useRouter<{ exerciseId: number, claimTypeId: string, isCreateNew: 'true' | 'false' }>()

  const { isMobile } = useScreen()
  const { data: exerciseItem, isLoading } = useGetExerciseById({ claimId: query.exerciseId })
  const initialValue = useMemo(() => { return { relativeTypeId: 0, } }, [])
  const ExerciseFormValue = useSelector((state: RootState) => state.exercise.ExerciseInfo) as ExerciseInfoWithoutConcentDate & ExerciseInfoWithConcentDate

  return (
    <Loading loading={false}>
      <BackgroundHeader />
      <Layout>
        <Headbar title={exerciseItem?.name || ''} backWard={paths.exercise()} />
        {/* <EClaimInfo eClaimItem={eClaimItem} /> */}

        {/*   <EClaimDocument /> */}

        <ExerciseForm exerciseItem={exerciseItem} exerciseFormValue={ExerciseFormValue} exerciseId={query.exerciseId} allpayStatus={false} isCreateNew={query.isCreateNew} />
      </Layout>
    </Loading>
  )
}

export default ExerciseDetail